export default __webpack_public_path__ + "static/media/twentyeightdays3.ac539bda.jpg";